<template>
<div class="mt_140">

  <ccMenu ref="cc_menu" v-bind:posicao=3></ccMenu>
  <ccLoading v-show="loading" ref="cc_loading"></ccLoading>

  <div class="container">

    <div class="row">
    <div class="col-4">
        <div class="row mb-3">
          <div class="col-6">
            <select class="form-control form-control-sm" v-model="frm_torneio_tipo" @change="filtro_tipo(frm_torneio_tipo)">
              <option value=0 selected>Tipos de Torneios</option>
              <option value=1>Um contra o outro</option>
              <option value=2>Preço fixo</option>
              <option value=3>Torneios grátis</option>
            </select>
          </div>
          <div class="col-6">
            <select class="form-control form-control-sm" v-model="frm_torneio_buy_in" @change="filtro_buy_in(frm_torneio_buy_in)">
              <option value="all">Valor de entrada</option>
              <option value="r1">0 - 5R$</option>
              <option value="r2">R$5 - R$30</option>
              <option value="r3">R$30 - R$100 </option>
              <option value="r4">R$100 - em diante  </option>
            </select>
          </div>
        </div>
    </div>
    </div>

    <div v-if="tor.length == 0" class="text_18 text_branco text-center">
      Nenhum torneio acontecendo!!!
    </div>

    <div v-if="tor.length > 0" v-for="t in tor" class="row mb-3">
      <div class="col-12">
        <div class="card text_branco p-2" style="text-decoration: none; cursor:pointer;">

            <div class="row">
              <div class="col-8">

                <div class="text_22 text_bold text_branco"
                  @click="chamando_pagina_torneio(t.id)"
                  v-bind:class="[t.tipo_id==1?'text_roxo':'text_verde']"> #{{t.id}} {{t.nome}}
                </div>

                <div class="text_10" @click="chamando_pagina_torneio(t.id)">
                  <span class="text_cinza">{{t.descricao_pagamento}}</span>
                </div>
              </div>

              <div class="col-4 text-end">
                <router-link :to="{name:'torneio_detalhes', params:{torneio_id:t.id,page_back:2} }"
                class="text_12 text_bold text_branco" style="cursor:pointer; text-decoration: underline;" > VER DETALHES
                </router-link>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div style="margin: 10px 10px 10px 0px; border-bottom:dashed #2F313C 2px;"></div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-9" @click="chamando_pagina_torneio(t.id)">
                <div class="text_10 mb-2 text_cinza">
                  Tipo Torneio: {{torneio_tipo_nome(t.tipo_id)}}
                </div>
                <div class="text_14 text_cinza">{{t.qtd_aposta}}/{{t.max_pessoa}}</div>
                <div class="text_10 text_cinza">Entradas / Max</div>
              </div>
              <div class="col-md-3">
                <button class="btn btn_azul btn-sm w-100 mb-2" @click="chamando_pagina_torneio(t.id)">ACOMPANHE</button>
                <div class="text_10 text-end">Status: {{torneio_status_nome(t.status)}}</div>
                <div class="text_10 text_cinza text-end">Previsão de Termino: {{timestamp_dataBR(t.dt_termino_timestamp,3)}}</div>
              </div>
            </div>

        </div>
      </div>
    </div>

  </div>

  <ccFooter></ccFooter>

</div>
</template>

<script>
import axios from 'axios';
import ccMenu from '../layout/menu.vue'
import ccFooter from '../layout/footer.vue'
import ccLoading from '../cc_geral/cc_loading.vue'

export default {
  data () {
    return {
      //geral
      base_url_api: process.env.BASE_URL_API,
      user: {},
      loading: true,
      errors: [],

      //array
      orginal: [],
      tor: [],

      //filtro
      frm_torneio_tipo: 0,
      frm_torneio_buy_in: 'all',

      //paginação
      page: 1,
      page_ultimo: 0,

      //variaveis
      qtd_total_andamento: 0,
      timer_minutos: null,
    }
  },

  components: {ccMenu, ccFooter, ccLoading},

  created(){
    document.title = 'Torneios: Acontecendo - SokkerDuel';

    localStorage.setItem("base_url_api_mobile", this.base_url_api);
  },

  mounted(){
    let a = JSON.parse(localStorage.getItem("user"));

    this.torneio_acontecendo()

    this.start_time_atualizar()
  },

  methods: {

    torneio_acontecendo(){
      this.loading = true;

      var header = {'headers': {'x-access-token': this.user.access_token, }};
      axios.get(this.base_url_api+'torneio/acontecendo', header)
      .then(response => {

        //receba todos os dados
        this.original = response.data.resp;

        this.higienizar_filtro()

        this.loading = false
      })
      .catch(e => {
        this.errors.push(e);
      });
    },


    higienizar_filtro(){
      let agora = Date.now()
      let seg = 0; let min = 0; let hora = 0; let dif = 0;
      let proximo = 999999999999999;

      var auxiliar = []
      var obj = {}
      this.tor = []
      var a = this.original
      this.tor = a
      let aux = []
      let aux2 = []

      //filtro tipo
      for (var i=0; i <= a.length -1; i++){
          if( a[i].tipo_id == this.frm_torneio_tipo || this.frm_torneio_tipo == 0 ){

            dif = ( (a[i].dt_inicio_timestamp * 1000) - agora )
            dif = parseInt(dif/1000);

            obj = {
              id: a[i].id,
              nome: a[i].nome,
              tipo_id: a[i].tipo_id,
              sumario: a[i].sumario,
              dt_inicio_timestamp: a[i].dt_inicio_timestamp,
              descricao_pagamento: a[i].descricao_pagamento,
              taxa_entrada: a[i].taxa_entrada,
              min_pessoa: a[i].min_pessoa,
              max_pessoa: a[i].max_pessoa,
              max_reentrada: a[i].max_reentrada,
              qtd_aposta: a[i].qtd_aposta,
              qtd_jogo: a[i].qtd_jogo,
              qtd_mercado_obrigatorio: a[i].qtd_mercado_obrigatorio,
              prize: a[i].prize,
              status: a[i].status,
              status_nome: a[i].status_nome,
              destaque: a[i].destaque,
              dt_termino_timestamp: a[i].dt_termino_timestamp,
            }

            aux.push(obj);
        }
      }

      //filtro buy_in
      if (this.frm_torneio_buy_in == 'r1') {
        aux = aux.filter((item) => item.taxa_entrada > 0  && item.taxa_entrada <= 5)
      } else if (this.frm_torneio_buy_in == 'r2') {
        aux = aux.filter((item) => item.taxa_entrada > 5  && item.taxa_entrada <= 30)
      } else if (this.frm_torneio_buy_in == 'r3') {
        aux = aux.filter((item) => item.taxa_entrada > 30  && item.taxa_entrada <= 100)
      } else if (this.frm_torneio_buy_in == 'r4') {
        aux = aux.filter((item) => item.taxa_entrada > 100)
      }

      this.tor = aux
    },

    chamando_pagina_torneio(n){
      var self = this;
      self.$router.push({path: '/torneio/'+n});
    },

    filtro_tipo(tipo){
      this.frm_torneio_tipo = tipo
      this.torneio_acontecendo()
    },

    filtro_buy_in(value){
      this.frm_torneio_buy_in = value
      this.torneio_acontecendo()
    },

    start_time_atualizar(){
      this.timer_atualizar = setInterval( function(){
          this.torneio_acontecendo()
      }.bind(this), 60000);
    },

  },

  destroyed(){
    clearInterval(this.timer_torneio_horario);
    clearInterval(this.timer_atualizar);
  },

}
</script>

<style scoped>

.form-control {
  color: #fff;
  background-color: #333644;
  border: none;
}

.card{
  background: transparent linear-gradient(72deg, #FFFFFF00 0%, #80808033 100%) 0% 0% no-repeat padding-box;
  box-shadow: 3px 3px 8px #00000029;
}

.btn{
  font-size: 10px;
  border-radius: 5px;
  opacity: 1;
}

.btn_azul{
  color: orange;
  border: 1px solid #ed9e0d;
}

.page-item{
  padding: 10px;
  background-color: transparent;
}

.page-link{
  background-color: transparent;
  text-decoration: none;
  font-size: 15px;
  font-family: bold;
  color: #cccccc;
  border: solid 1px #20222d;
}

</style>



// WEBPACK FOOTER //
// src/components/acontecendo/acontecendo.vue